// Cart add-ons form submission with event delegation and AJAX
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('cart-add-ons-form')) {
    e.preventDefault();
    
    const form = e.target;
    const button = form.querySelector('button[type="submit"]');
    const originalText = button.querySelector('.button-text').textContent;
    
    // Show loading state
    button.disabled = true;
    button.querySelector('.button-text').textContent = 'Adding...';
    
    const variantId = form.querySelector('[name="id"]').value;
    
    // Check if gift card is in cart before adding
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        // Check for gift card in cart
        const hasGiftCard = cart.items.some(item => item.handle === 'rise-ai-giftcard');
        if (hasGiftCard) {
          console.warn('Cannot add products when gift card is in cart');
          button.querySelector('.button-text').textContent = originalText;
          button.disabled = false;
          return;
        }
        
        const payload = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        // C-3: Use CartDrawer.addToCart (namespaced static method) instead of implicit global.
        CartDrawer.addToCart(payload);
        
        // Reset button after a short delay
        setTimeout(() => {
          button.querySelector('.button-text').textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch((error) => {
        console.error('Error checking cart:', error);
        button.querySelector('.button-text').textContent = originalText;
        button.disabled = false;
      });
  }
});

// Cart add-ons dots functionality
// Scoped per-container (not a single global querySelector) in case more than one
// .cart-add-ons rail ever renders in the drawer at once -- each is its own container
// with its own .slider and .cart-add-on-dot set.
function initializeCartAddOnsDots() {
  const containers = document.querySelectorAll('.cart-add-ons');
  let foundAny = false;

  containers.forEach((container) => {
    const slider = container.querySelector('.slider');
    const dots = container.querySelectorAll('.cart-add-on-dot');
    if (!slider || dots.length === 0) return;
    foundAny = true;

    // Skip sliders that are already wired up. The MutationObserver below watches
    // the entire document body for any childList change (third-party embed
    // scripts, unrelated cart widgets, etc. all qualify), so without this guard
    // it can re-fire mid-scroll: initializeSliderDots() unconditionally reset
    // scrollLeft back to 0 every time it ran, which looked like "clicking dot 3
    // just scrolls back to the first product" if that reset landed while the
    // smooth-scroll animation from the click was still in flight. A genuinely
    // new slider (e.g. after a real cart-drawer HTML replacement) won't carry
    // this flag, since it's a brand-new element, so it still gets initialized.
    if (slider.dataset.dotsInitialized === 'true') return;
    slider.dataset.dotsInitialized = 'true';
    initializeSliderDots(slider, dots);
  });

  if (!foundAny) {
    // If elements aren't found, try again after a short delay
    setTimeout(initializeCartAddOnsDots, 200);
  }
}

function initializeSliderDots(slider, dots) {
  const slides = slider.querySelectorAll('.cart-add-on-slide');
  let currentActiveIndex = 0;
  let isScrolling = false; // Flag to prevent scroll handler during programmatic scroll

  // Slide position relative to the slider's scrollable content. Using
  // getBoundingClientRect (rather than offsetWidth * index) accounts for the
  // gap between flex slides -- assuming a uniform slideWidth undercounted the
  // real position by (gap * index), so the computed scroll target didn't match
  // where CSS scroll-snap would land, and the snap correction after each
  // programmatic scroll showed up as a visible jump.
  function slidePosition(slide) {
    return slide.getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft;
  }

  // Function to update active dot
  function updateActiveDot(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle('slider-counter__link--active', i === index);
    });
    currentActiveIndex = index;
  }

  // Function to scroll to specific slide
  function scrollToSlide(index) {
    const slide = slides[index];
    if (slide) {
      isScrolling = true; // Set flag before scrolling
      slider.scrollTo({
        left: slidePosition(slide),
        behavior: 'smooth'
      });

      // Clear flag after scroll animation completes
      setTimeout(() => {
        isScrolling = false;
      }, 500);
    }
  }

  // Add click event listeners to dots. This function now only ever runs once per
  // slider element (see the dotsInitialized guard in initializeCartAddOnsDots),
  // so there's nothing to deduplicate here anymore.
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function(e) {
      e.preventDefault();
      updateActiveDot(index); // Update immediately on click
      scrollToSlide(index);
    });
  });

  // Update active dot based on scroll position
  slider.addEventListener('scroll', function() {
    // Don't update if we're in the middle of a programmatic scroll
    if (isScrolling) return;

    const scrollLeft = slider.scrollLeft;
    let newIndex = 0;
    let closestDistance = Infinity;
    slides.forEach((slide, i) => {
      const distance = Math.abs(slidePosition(slide) - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        newIndex = i;
      }
    });

    if (newIndex !== currentActiveIndex) {
      updateActiveDot(newIndex);
    }
  });

  // Initialize active dot - ensure we're at the beginning
  slider.scrollLeft = 0;
  updateActiveDot(0);
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initializeCartAddOnsDots);

// Listen for cart updates to re-initialize dots
if (typeof subscribe !== 'undefined') {
  subscribe('cart:updated', function() {
    setTimeout(initializeCartAddOnsDots, 100);
  });
}

// Also listen for general DOM changes that might affect the cart add-ons
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Check if cart add-ons were added or updated
      const cartAddOns = document.querySelector('.cart-add-ons');
      if (cartAddOns && (mutation.target.contains(cartAddOns) || cartAddOns.contains(mutation.target))) {
        setTimeout(initializeCartAddOnsDots, 100);
      }
    }
  });
});

// Start observing when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 